export default __webpack_public_path__ + "static/media/3.788a7e8d.svg";